// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1Pi2i","insightsList":"newBusinessInsightsMenu_insightsList__20Yuq","active":"newBusinessInsightsMenu_active___ZJ4n"};